/** What a message of your own says about itself, inside its bubble (spec §3.2): on its way, sent, read, read by all. */
export type Receipt = 'pending' | 'failed' | 'sent' | 'read' | 'all'

interface Args {
  mine: boolean
  /** An outbox row's state while the message is still on this device. */
  pending: 'sending' | 'failed' | null
  seq: number
  /** How far each person has read, by user id (the channel's read positions). */
  reads: Record<string, number>
  /** Everyone else who can read the message: the members, without you and without bots, which never read. */
  audience: string[]
}

export function receiptFor({ mine, pending, seq, reads, audience }: Args): Receipt | null {
  if (!mine) return null
  if (pending) return pending === 'failed' ? 'failed' : 'pending'
  const readers = audience.filter((id) => (reads[id] ?? -1) >= seq)
  if (readers.length === 0) return 'sent'
  return readers.length === audience.length ? 'all' : 'read'
}
